import { format } from "date-fns";
import { Header, Container, Content } from "./styles";
import { Modal } from "../../../../../components/Modal";
import { Separator } from "../../../../../components/Topbar/styles";
import { i18n } from "../../../../../localization/i18n";

interface IMeasureHistoryModal {
  updated_at: Date;
  measures: string[];
}

interface IProps {
  open: boolean;
  toggleModal: () => void;
  data: IMeasureHistoryModal[];
}

export default function MeasureHistoryModal({ toggleModal, open, data }: IProps) {

  function formatDate(date: string) {
    date.replace("Z", "");
    return format(new Date(date), "dd/MM/yyyy");
  }


  return (
    <Modal open={open} onRequestClose={toggleModal}>
      <Header>Histórico de medidas</Header>
      <Container>
        {
          data.map((measuresHistory) => {
            return (
              <Content>
                <strong>{formatDate(String(measuresHistory.updated_at))}</strong>
                {measuresHistory.measures.map((measure, i) => (
                  <>
                    <span>{`${i18n.t('evaluation.measure')} ${i + 1}: ${measure}`}</span>
                  </>
                ))}
              </Content>
            )
          })
        }
      </Container>
      <Separator />
    </Modal>
  )
}
